import { Box, Divider, Typography, IconButton } from "@mui/material";
import googleButton from "../../assets/Link.svg";
import appleButton from "../../assets/Icons/apple.svg";
import facebook from "../../assets/Icons/facebook 1.svg";
import instagram from "../../assets/Icons/instagram 1.svg";
import linkedin from "../../assets/Icons/googles.svg";
import youtube from "../../assets/Icons/youtube.svg";
import tiktok from "../../assets/Icons/tiktok.svg";
import thread from "../../assets/Icons/email.svg";
import twitter from "../../assets/Icons/twitter 1.svg";
import { Link } from "react-router-dom";
import logo from "../../assets/Logo/logo-new.svg";
import MaContainer from "./container";

const Footer = () => {
  // const classes = useStyles();
  return (
    <>
      <Box sx={{ bgcolor: "#2E1834", py: 6 }}>
        <MaContainer>
        <div className=" md:flex-row flex-col flex justify-between gap-10">
          {/* First Column Container  */}
          <div className="md:w-[27%] w-[80%]">
            <div>
              <img
                src={logo}
                alt="Mamaket Logo"
                style={{ width: "120px", height: "auto" }}
              />
              <div className="mt-2">
                <span className="text-[#FFFFFFCC] italic text-[13px]">
                  A cultural discovery marketplace , connecting communities
                  through authentic products, foods, and stories from around the
                  world.
                </span>
              </div>
            </div>

            <Box>
              <Box sx={{ ml: -1 }}>
                <a href="https://www.facebook.com/me/">
                  <IconButton>
                    <img src={facebook} />
                  </IconButton>
                </a>
                <a href="https://twitter.com/MamaketN">
                  <IconButton>
                    <img src={twitter} />
                  </IconButton>
                </a>
                <a href="https://www.instagram.com/mamaketinc/">
                  <IconButton>
                    <img src={instagram} />
                  </IconButton>
                </a>
                <a href="https://www.linkedin.com/company/99913366/admin/feed/posts/">
                  <IconButton>
                    <img src={linkedin} />
                  </IconButton>
                </a>
                <a href="https://www.youtube.com/channel/UCRtYYp9Rn06y2ben4m53KiQ ">
                  <IconButton>
                    <img src={youtube} />
                  </IconButton>
                </a>
                <a href="https://www.tiktok.com/@mamaketinc?_t=8gy5D1DL7Cv&_r=1">
                  <IconButton>
                    <img src={tiktok} />
                  </IconButton>
                </a>
                <a href="https://threads.net/@mamaketinc">
                  <IconButton>
                    <img src={thread} />
                  </IconButton>
                </a>
              </Box>
            </Box>
          </div>

          {/* Second Column Container */}
          <div className="flex-1 ">
            <div className="flex justify-between">
              {/* MAMAKET */}
              <Box sx={{ flex: 1 }}>
                <p className="dm-sans py-0 my-0 text-[13px] font-bold text-white">
                  MAMAKET
                </p>
                <div className="mt-4 !text-[#f8f8f8d2] text-[13px] flex flex-col gap-y-3">
                  <Link to="/about-us">
                    <span className="">About Us</span>
                  </Link>
                  <Link to="/blog">
                    <span className=""> Our Blog</span>
                  </Link>

                  <Link to="/contact">
                    <span className="">Contact Us</span>
                  </Link>
                  <Link to="/sell-on-mamaket">
                    <span className="">Ma for Sellers</span>
                  </Link>
                </div>
              </Box>

              {/* EXPLORE */}
              {/* <Box sx={{ flex: 1 }}>
                <p className="dm-sans py-0 my-0 text-[13px] font-bold text-white">
                  EXPLORE
                </p>
                <div className="mt-4 !text-[#f8f8f8d2] text-[13px] flex flex-col gap-y-3">
                  <Link to="/faq">
                    <span className="">All Categories</span>
                  </Link>
                  <Link to="/blog">
                    <span className="">Product Origins</span>
                  </Link>

                  <Link to="/contact">
                    <span className="">Trending Now</span>
                  </Link>
                  <Link to="/contact">
                    <span className="">Cultural Festivals</span>
                  </Link>
                  <Link to="/contact">
                    <span className="">Ask Ma</span>
                  </Link>
                </div>
              </Box> */}
              {/* SELLERS */}
              <Box sx={{ flex: 1 }}>
                <p className="dm-sans py-0 my-0 text-[13px] font-bold text-white">
                  SELLERS
                </p>
                <div className="mt-4 !text-[#f8f8f8d2] text-[13px] flex flex-col gap-y-3">
                  <Link to="/become-a-seller">
                    <span className="">Become a seller</span>
                  </Link>
                  <Link to="/sell-on-mamaket">
                    <span className="">Seller Dashboard</span>
                  </Link>

                  <Link to="/verification">
                    <span className="">Seller Guidelines</span>
                  </Link>
                  {/* <Link to="/contact">
                    <span className="">Ma for Sellers</span>
                  </Link> */}
                </div>
              </Box>

                 {/* BUYING ON MAMAKET */}
              <Box sx={{ flex: 1 }}>
                <p className="dm-sans py-0 my-0 text-[13px] font-bold text-white">
                  BUYING ON MAMAKET
                </p>
                <div className="mt-4 !text-[#f8f8f8d2] text-[13px] flex flex-col gap-y-3">
                  <Link to="/faq">
                    <span className="">FAQs</span>
                  </Link>
                  <Link to="/return-policy">
                    <span className="">Return Policy</span>
                  </Link>

                  <Link to="/account/orders">
                    <span className="">Track My Orders</span>
                  </Link>
                  <Link to="/contact">
                    <span className="">Help Center</span>
                  </Link>
                </div>
              </Box>

            
            </div>
            <div className="flex justify-between mt-10">
              {/* Company */}
              <Box sx={{ flex: 1 }}>
                <p className="dm-sans py-0 my-0 text-[13px] font-bold text-white">
                 EXPLORE
                </p>
                <div className="mt-4 !text-[#f8f8f8d2] text-[13px] flex flex-col gap-y-3">
                  <Link to="/mamapurse">
                    <span className="">Mamapurse</span>
                  </Link>
                  <Link to="/footer-product">
                    <span className="">Product Guidelines</span>
                  </Link>

              
                  <Link to="/contact">
                    <span className="">Help Center</span>
                  </Link>
                 
                </div>
              </Box>
     {/* MORE INFO */}
              <Box sx={{ flex: 1 }}>
                <p className="dm-sans py-0 my-0 text-[13px] font-bold text-white">
                  MORE INFO
                </p>
                <div className="mt-4 !text-[#f8f8f8d2] text-[13px] flex flex-col gap-y-3">
                  <Link to="/privacy-policy">
                    <span className="">Privacy Policy</span>
                  </Link>
                  <Link to="/terms&conditions">
                    <span className="">Terms & Conditions</span>
                  </Link>
                  {/* <a target="_blank"  href="https://foundingcouncil.mamaket.com/">
                    <span className="">Founders' Council</span>
                  </a> */}
                </div>
              </Box>
           
           
            </div>
          </div>

          {/* Third Column Container */}

          <div>
            <Box>
              <Typography sx={{ color: "#fff", fontWeight: 600 }}>
                Download Mobile App
              </Typography>
              <Box sx={{ ml: -1 }}>
                <a href="https://play.google.com/store/apps/details?id=com.mamaket.mobile2026">
                <IconButton>
                  <img src={googleButton} alt="google_download_button" />
                </IconButton>
                </a>
                <a href="https://apps.apple.com/ng/app/mamaket-mobile/id6469295262">
                  <IconButton>
                    <img src={appleButton} alt="apple_download_button" />
                  </IconButton>
                </a>
              </Box>
            </Box>
          </div>
        </div>
        </MaContainer>

        <Divider
          sx={{
            bgcolor: "#FFFFFF12",
            margin: "0 auto",
            width: "90%",
            mt: 9,
          }}
        />
        <div className="flex items-center flex-col pt-10">
          <span className="text-[#FFFFFF4D] text-[12px]">
            © 2026 Mamaket Global, Inc. All rights reserved. · Privacy · Terms
          </span>
          <span className="py-2 px-4 rounded-full mt-4 text-[#FFFFFF66] text-[11px] border-[#FFFFFF14] border border-solid bg-[#FFFFFF0D]">
            Powered by Ma
          </span>
        </div>
      </Box>
    </>
  );
};

export default Footer;
